'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _PlanScorecardSelfDirectedOption = require('./PlanScorecardSelfDirectedOption.css');

var _PlanScorecardSelfDirectedOption2 = _interopRequireDefault(_PlanScorecardSelfDirectedOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardSelfDirectedOption = (_dec = (0, _reactCssModules2.default)(_PlanScorecardSelfDirectedOption2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardSelfDirectedOption, _Component);

  function PlanScorecardSelfDirectedOption(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardSelfDirectedOption);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardSelfDirectedOption.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardSelfDirectedOption)).call(this, props));

    _this.state = {
      // planData: props.planData,
      hasSelfDirectedOption: props.planData.access_self_directed && props.planData.access_self_directed.length > 0,
      hasAccessHeadline: 'This plan has a self-directed option that may ' + 'offer access to sustainable funds.',
      hasNoAccessHeadline: 'This plan has no ' + 'self-directed option.'
    };
    return _this;
  }

  (0, _createClass3.default)(PlanScorecardSelfDirectedOption, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          hasSelfDirectedOption = _state.hasSelfDirectedOption,
          hasAccessHeadline = _state.hasAccessHeadline,
          hasNoAccessHeadline = _state.hasNoAccessHeadline;


      var iconSelfDirected = require('../../../static/images/icon-self-directed.png');

      //
      return _react2.default.createElement(
        'div',
        { styleName: hasSelfDirectedOption ? 'brokerage-wrap' : 'no-brokerage-wrap'
        },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'brokerage-inner' },
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 12 },
              _react2.default.createElement(
                'div',
                { styleName: 'brokerage-flex' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { styleName: 'brokerage-flex-label' },
                    'Self-directed option'
                  ),
                  _react2.default.createElement(
                    'h3',
                    { styleName: 'brokerage-flex-text' },
                    hasSelfDirectedOption ? hasAccessHeadline : hasNoAccessHeadline
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'brokerage-flex-sublede' },
                    hasSelfDirectedOption ? _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'p',
                        null,
                        'A ',
                        _react2.default.createElement(
                          _components.Link,
                          {
                            to: _config2.default.routes.faqs + '#is-offering-a-self-directed-option-brokerage-window-enough-',
                            title: 'Is offering a self-directed option (brokerage window) enough?',
                            xstrong: true
                          },
                          'self-directed option'
                        ),
                        ' (also called a "brokerage window") can provide more access to sustainable funds. But a self-directed option requires more effort from plan participants, and could lead to riskier investments. It\'s better for retirement plans to offer sustainable funds without making people use a self-directed option - or even better, to make the default investment sustainable.'
                      ),
                      _react2.default.createElement(
                        'p',
                        null,
                        'If your plan has a self-directed option, you can use our ',
                        _react2.default.createElement(
                          _components.Link,
                          {
                            to: _config2.default.routes.mutualFundsETFs,
                            title: 'Mutual funds and ETFs',
                            xstrong: true
                          },
                          'database of mutual funds and ETFs'
                        ),
                        ' to find sustainable funds that meet your investment needs.'
                      )
                    ) : _react2.default.createElement(
                      'p',
                      null,
                      'A ',
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#is-offering-a-self-directed-option-brokerage-window-enough-',
                          title: 'Is offering a self-directed option (brokerage window) enough?'
                        },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'white-xstrong' },
                          'self-directed option'
                        )
                      ),
                      ' (also called a "brokerage window") can provide plans more access to sustainable funds. Without one, plan participants are restricted to the plan options approved by the plan administrator, usually between 20 and 30 funds, and usually not including many (if any) sustainable funds. We found no evidence this plan includes a self-directed option.'
                    )
                  )
                ),
                hasSelfDirectedOption ? _react2.default.createElement(
                  'div',
                  { styleName: 'brokerage-icon' },
                  _react2.default.createElement('img', {
                    src: iconSelfDirected,
                    alt: 'This plan has a self-directed option that may offer access to sustainable funds.'
                  })
                ) : null
              )
            )
          )
        )
      );
    }
  }]);
  return PlanScorecardSelfDirectedOption;
}(_react.Component), _class2.propTypes = {
  planData: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PlanScorecardSelfDirectedOption;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardSelfDirectedOption/PlanScorecardSelfDirectedOption.js
// module id = 1425
// module chunks = 0